/**
 * Created by vsliwka on 21/04/2017.
 */
export class WorkVersionOriginModel {
  public id: number;
  public label: string;
  public value: number;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
